<template>
<div>
    <Topside /> 
  <div class="main">
    <div class="box">

      <div class="boxtitle">データベース概要</div>
      <div class="box-1 box-scroll">

        <div v-html="contentsData.Content4"></div> 
        <Sitemap/>
      </div>
    </div>
  </div>


  </div>
</div>

</template>
</tamplate>

<script>
import Topside from '@/components/Treeside.vue'
import Sitemap from '@/components/Sitemap.vue'

// @ is an alias to /src
import axios from 'axios'
export default {
  //name: 'Riyou',
  name: 'guide',
  components: {
    Topside,
    Sitemap
  },
  computed: {
    /**
      * コンテンツの取得
      */
    contentsData() {
      return this.$store.getters.content
    }
  },
  created: function() {
    var self = this
    self.init()
  },

  
  data () {
    return {
      //kaisodata: []
      //contentsData: [] //コンテンツデータ
    }
  },
  mounted: function () {
    var self = this
    self.init()
    
  },
  methods: {
    init () {
      this.getAllKaisoData(function(res){})
    },
  }
}
</script>